import React from "react";
import "./Mobile_Payment_Success_Modal.css";
import Successfull_Lottie from "../../Animation/Successfull_Lottie/Successfull_Lottie";

function Mobile_Payment_Success_Modal({ successText, ...props }) {
  const handleGoBackToApp = () => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("orderId");

    if (!orderId) {
      return;
    }

    window.location.href = `riyara://payment/success?order_id=${orderId}`;
  };

  return (
    <>
      <section className="Success_modal Payment_Success_Modal">
        <div>
          <Successfull_Lottie successText="Order Placed Successfully" />
        </div>

        <div className="text-center mt-3">
          <h4>Your order has been placed successfully!</h4>

          <p>
            Thank you for your purchase. We've received your order and will
            process it shortly.
          </p>

          <button
            type="button"
            className="go_back_app_btn"
            onClick={handleGoBackToApp}
          >
            Go Back to App
          </button>
        </div>
      </section>
    </>
  );
}

export default Mobile_Payment_Success_Modal;
